import React from 'react'
import Notification from 'src/Components/shared/Notification'
import Routes from 'src/routes'
import BombBomb from './BombBomb'
import DisclaimerModal from './DisclaimerModal'
import ErrorModal from './ErrorModal'
import { hot, setConfig } from 'react-hot-loader'

const App = ({ error }) => (
  <>
    <Notification />
    <Routes />
    <BombBomb />
    <DisclaimerModal />
    {error && <ErrorModal />}
  </>
)

// May be able to get hooks running as they should one day, but
// hot rerenders seem to loose track of deps and reruns all hooks
// including those in Reports and FetchRoutes that dispatch server
// requests. reload: false > loading spinner.
setConfig({
  reloadHooks: false
})

export default hot(module)(App)
